
import HelpfulLinkShow from '../components/helpful_links/HelpfulLinkShow.vue';
import Vue from 'vue';

Vue.component('helpful-link-show', HelpfulLinkShow);

export default Vue.extend({});
